<div class="jobseekers">
  <div class="row">
    <div class="filter-container col-md-2">
      <div class="filters-input-container">
        <div class="filter-inputs">
          <div class="input-header">{{ 'label.Website' | translate }}</div>
          <div>
            <select [(ngModel)]="filterPagingWrapper.filter.providerWebsite">
              <option
                *ngFor="let item of providerWebsiteList"
                [value]="item.value"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-inputs">
          <div class="input-header">{{ 'label.ProfileState' | translate }}</div>
          <div>
            <select [(ngModel)]="filterPagingWrapper.filter.profileState">
              <option *ngFor="let item of profileStates" [value]="item.value">
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-inputs">
          <!--<div class="input-header">{{"label.ModerationStatus" | translate }}</div>
          <div>
            <select [(ngModel)]="filterPagingWrapper.filter.moderationStatus">
              <option
                *ngFor="let item of switchModerationStatuses"
                [value]="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>-->
          <div class="filter-inputs-moderation">
            <div class="moderation-count" *ngIf="totalModeration != null">
              <input
                type="checkbox"
                name="moderation"
                id="lbl-moderation"
                [(ngModel)]="filterPagingWrapper.filter.isInModeration"
              />
              <label for="lbl-moderation">{{
                ('label.InModeration' | translate) + '(' + totalModeration + ')'
              }}</label>
            </div>
          </div>
        </div>
        <div class="filter-inputs">
          <div class="input-header">{{ 'label.Email' | translate }}</div>
          <div>
            <input type="text" [(ngModel)]="filterPagingWrapper.filter.email" />
          </div>
        </div>
        <div class="filter-inputs">
          <div class="input-header">{{ 'label.Phone' | translate }}</div>
          <div>
            <input
              type="text"
              [(ngModel)]="filterPagingWrapper.filter.phoneNumber"
            />
          </div>
        </div>
        <div class="filter-inputs-moderation">
          <!--<div class="moderation-count">
          <div class="moderation-count" *ngIf="totalModeration != null">
            <input type="checkbox" name="moderation" id="moderation" [(ngModel)]="filterPagingWrapper.filter.isInModeration">
            <label for="moderation">{{('InModeration' | translate) + '(' + totalModeration + ')'}}</label>
          </div>-->
        </div>
        <!-- <div>
                <div>{{"label.DrivingLicence" | translate}}:</div>
                <div class="multi-select-dropdown">
                    <ul>
                        <li *ngFor="let item of selectedDrivingLicenses">
                            {{item.text}}<button class="remove" (click)="onSelectedDrivingLicenceFilterRemoveClick(item)">×</button>
                        </li>
                    </ul>
                    <select [(ngModel)]="lastSelectedDrivingLicenceFilter" (ngModelChange)="onDrivingLicenceFilterChange()">
                        <option *ngFor="let item of drivingLicenses" [value]="item.value">{{item.text}}</option>
                    </select>
                </div>
            </div> -->
        <!-- <div>
                <div>{{"label.Event" | translate}}:</div>
                <div>
                    <select [(ngModel)]="filterPagingWrapper.filter.eventId">
                        <option *ngFor="let item of activeEvents" [value]="item.value">{{item.text}}</option>
                    </select>
                </div>
            </div> -->
        <!-- <div class="control-custom">
                <div>{{'label.IndustryCategory' | translate }}</div>
                <div class="multi-select-dropdown">
                    <ul>
                        <li *ngFor="let category of selectedCategories">
                            {{category?.name}}<button class="remove" (click)="onCategoryOptionRemoveClick(category)">x</button>
                        </li>
                    </ul>
                </div>
                <p-multiSelect [options]="categoryOptions" [(ngModel)]="selectedCategories" (onChange)="onCategoryFilterChange($event)" [filter]="true"
                    [maxSelectedLabels]="0" [showToggleAll]="false" selectedItemsLabel="{{'label.Selected' | translate }}: {0}" [style]="{width:'100%'}">
                    <ng-template let-item pTemplate="item">
                        <span (click)="onCategoryClick(item.value)" class="{{item.value.isHeadOld() ? 'head-occupation-category' : 'occupation-category'}}">{{item.label}}</span>
                    </ng-template>
                </p-multiSelect>
            </div> -->
        <!-- <div>
                <div>{{"label.HasCV" | translate}}:</div>
                <div>
                    <input type="checkbox" [(ngModel)]="filterPagingWrapper.filter.hasCV" />
                </div>
            </div> -->
        <div class="c-date-picker filter-inputs">
          <div class="input-header">
            {{ 'label.RegistrationDate' | translate }}
          </div>
          <hr-date-range-picker
            class="date-picker"
            [dateFormat]="specialDateFormat"
            [style]="{
              width: '175px',
              height: '38px',
              border: '1px solid #ddd',
              'min-width': '5em'
            }"
            [(ngModel)]="filterPagingWrapper.filter.registrationDate"
          ></hr-date-range-picker>
        </div>
        <div class="c-date-picker filter-inputs">
          <div class="input-header">{{ 'label.LastVisit' | translate }}</div>
          <hr-date-range-picker
            class="date-picker"
            [dateFormat]="specialDateFormat"
            [style]="{
              width: '175px',
              height: '38px',
              border: '1px solid #ddd',
              'min-width': '5em'
            }"
            [(ngModel)]="filterPagingWrapper.filter.lastVisitDate"
          ></hr-date-range-picker>
        </div>
        <div class="filter-inputs-pending">
          <div class="moderation-count">
            <input
              type="checkbox"
              name="pending"
              id="lbl-pending"
              [(ngModel)]="filterPagingWrapper.filter.isPending"
            />
            <label for="lbl-pending">{{ 'label.Pending' | translate }}</label>
          </div>
        </div>
        <div class="cv-search">
          <span class="cv-search-header">{{
            'label.CvSearch' | translate
          }}</span>
          <div class="cv-search-container">
            <div class="filter-inputs">
              <div class="input-header">{{ 'label.Keyword' | translate }}</div>
              <div>
                <input
                  type="text"
                  [(ngModel)]="filterPagingWrapper.filter.keyWord"
                />
              </div>
            </div>
            <div class="location-picker">
              <hr-location-picker
                [(ngModel)]="selectedLocationsPath"
                [formControl]="extendedLocationPath"
                class="form-item__label locality__value"
                [displayHorizontal]="true"
                [displayHeader]="true"
                [locationLevelCount]="locationLevelCount"
                [firstLevelParentLocationId]="locationFirstLevelId"
                [requiredLevelCount]="0"
                [lastHiddenLevelCount]="jobseekerLocationLastHiddenLevelCount"
              >
              </hr-location-picker>
            </div>
          </div>
        </div>
        <div class="work-experience-filter">
          <div class="work-experience-inputs">
            <div class="filter-inputs">
              <div class="input-header">
                {{ 'label.SpecializationPosition' | translate }}
              </div>
              <p-multiSelect
                [options]="specializationOptions"
                [(ngModel)]="selectedSpecializations"
                (onChange)="onSpecializationFilterChange($event)"
                [filter]="true"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                [maxSelectedLabels]="0"
                [showToggleAll]="false"
                selectedItemsLabel="{{ 'label.Selected' | translate }}: {0}"
                class="specializations"
                [style]="{
                  width: '100%',
                  height: '38px',
                  border: '1px solid #DDD'
                }"
              >
                <ng-template let-item pTemplate="item">
                  <span
                    (click)="onSpecializationClick($event, item.value)"
                    class="{{
                      item.value.isHead
                        ? 'head-specialization'
                        : 'specialization'
                    }}"
                    >{{ item.label }}</span
                  >
                </ng-template>
              </p-multiSelect>
            </div>
            <div class="c-date-picker filter-inputs">
              <div class="input-header">
                {{ 'label.ExperienceYears' | translate }}
              </div>
              <div class="experience-years">
                <input
                  id="lbl-experience-from"
                  type="number"
                  min="0"
                  class="experience-years__from"
                  [(ngModel)]="filterPagingWrapper.filter.experienceFrom"
                  [disabled]="filterPagingWrapper.filter.isWihoutExperience"
                  #ef
                />
                <input
                  id="lbl-experience-to"
                  type="number"
                  [min]="ef.value ? +ef.value + 1 : 0"
                  class="experience-years__to"
                  [(ngModel)]="filterPagingWrapper.filter.experienceTo"
                  [disabled]="filterPagingWrapper.filter.isWihoutExperience"
                  #et
                />
              </div>
            </div>
            <div class="filter-inputs">
              <div class="input-header">
                {{ 'label.SearchWithCompanyName' | translate }}
              </div>
              <div>
                <input
                  type="text"
                  [(ngModel)]="filterPagingWrapper.filter.customerName"
                />
              </div>
            </div>
          </div>
          <div class="work-experience-checkboxes">
            <div class="filter-inputs-work-experience-checkboxes">
              <div class="moderation-count">
                <input
                  type="checkbox"
                  name="unemployed"
                  id="lbl-unemployed"
                  [(ngModel)]="filterPagingWrapper.filter.isUnemployed"
                />
                <label for="lbl-unemployed">{{
                  'label.CurrentlyUnEmployed' | translate
                }}</label>
              </div>
            </div>
            <div class="filter-inputs-work-experience-checkboxes">
              <div class="moderation-count">
                <input
                  type="checkbox"
                  name="without-experience"
                  id="lbl-without-experience"
                  (change)="onUnemployedCheck()"
                  [(ngModel)]="filterPagingWrapper.filter.isWihoutExperience"
                />
                <label for="lbl-without-experience">{{
                  'label.WithoutExperience' | translate
                }}</label>
              </div>
            </div>
            <div class="filter-inputs-work-experience-checkboxes">
              <div class="moderation-count">
                <input
                  type="checkbox"
                  name="current-experience"
                  id="lbl-current-experience"
                  [(ngModel)]="filterPagingWrapper.filter.onlyInLastJobs"
                />
                <label for="lbl-current-experience">{{
                  'label.OnlyCurrentExperience' | translate
                }}</label>
              </div>
            </div>
          </div>
          <div class="education-filter">
            <app-jobseeker-education-filter
              [educationLevelList]="educationLevelList"
              [educationalInstitutionList]="universityList"
              [educationalProgramList]="programList"
              [educationLevel]="selectedLevels"
              [institutions]="selectedInstitutions"
              [programs]="selectedPrograms"
              (selectInstitutions)="onSelectedInstitutions($event)"
              (selectPrograms)="onSelectedPrograms($event)"
              (selectEducationLevels)="onSelectedEducationLevels($event)"
            >
            </app-jobseeker-education-filter>
          </div>
          <div class="driving-license-filters">
            <div class="filter-inputs">
              <div class="input-header">
                {{ 'label.SearchByLanguage' | translate }}
              </div>
              <p-multiSelect
                [options]="languageOptions"
                [(ngModel)]="selectedLanguages"
                [filter]="true"
                [maxSelectedLabels]="0"
                [showToggleAll]="false"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                optionLabel="name"
                [style]="{
                  width: '380px',
                  height: '38px',
                  border: '1px solid #DDD'
                }"
              >
              </p-multiSelect>
            </div>
            <div class="filter-inputs">
              <div class="input-header">
                {{ 'label.DrivingLicence' | translate }}:
              </div>
              <div class="multi-select-dropdown">
                <select
                  [(ngModel)]="lastSelectedDrivingLicenceFilter"
                  (ngModelChange)="onDrivingLicenceFilterChange()"
                >
                  <option
                    *ngFor="let item of drivingLicenses"
                    [value]="item.value"
                  >
                    {{ item.text }}
                  </option>
                </select>
                <ul>
                  <li *ngFor="let item of selectedDrivingLicenses">
                    {{ item.text
                    }}<button
                      class="remove"
                      (click)="onSelectedDrivingLicenceFilterRemoveClick(item)"
                    >
                      ×
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="filter-inputs">
              <div class="filter-inputs-pending">
                <div class="moderation-count">
                  <input
                    type="checkbox"
                    name="own-vehicle"
                    id="lbl-own-vehicle"
                    (change)="onOwnTransportCheck()"
                    [(ngModel)]="filterPagingWrapper.filter.isVehicleOwner"
                  />
                  <label for="lbl-own-vehicle">{{
                    'label.OwnTransport' | translate
                  }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="document-type-filters">
            <div class="filter-inputs">
              <div class="filter-inputs-pending">
                <div class="moderation-count">
                  <input
                    type="checkbox"
                    name="document"
                    id="lbl-has-document"
                    (change)="onHasDocumentCheck()"
                    [(ngModel)]="filterPagingWrapper.filter.hasDocument"
                  />
                  <label for="lbl-has-document">{{
                    'label.HasDocumentUploaded' | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div
              class="filter-inputs"
              *ngIf="filterPagingWrapper.filter.hasDocument"
            >
              <div class="input-header">
                {{ 'label.DocumentType' | translate }}
              </div>
              <p-multiSelect
                [options]="documentOptions"
                [(ngModel)]="selectedDocumentTypes"
                [filter]="true"
                [maxSelectedLabels]="0"
                [showToggleAll]="false"
                optionLabel="name"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                selectedItemsLabel="{{ 'label.Selected' | translate }}: {0}"
                class="document-type"
                [style]="{
                  width: '380px',
                  height: '38px',
                  border: '1px solid #DDD'
                }"
              >
              </p-multiSelect>
            </div>
            <div
              class="filter-inputs"
              *ngIf="filterPagingWrapper.filter.isVehicleOwner"
            >
              <div class="input-header">
                {{ 'label.TransportType' | translate }}
              </div>
              <p-multiSelect
                [options]="vehicleOptions"
                [(ngModel)]="selectedVehicleTypes"
                [filter]="true"
                [maxSelectedLabels]="0"
                [showToggleAll]="false"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                optionLabel="name"
                selectedItemsLabel="{{ 'label.Selected' | translate }}: {0}"
                class="vehicle-type"
                [style]="{
                  width: '380px',
                  height: '38px',
                  border: '1px solid #DDD'
                }"
              >
              </p-multiSelect>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="apply" (click)="onApplyClick(dt)">
          {{ 'label.Filter' | translate }}
        </button>
        <button class="clear" (click)="onClearClick()">
          {{ 'label.Clear' | translate }}
        </button>
      </div>
    </div>

    <div class="list-container col-md-10">
      <div class="signin-links">
        <div class="public-portal-login"
          (click)="onLoginToPublicPortal(mainProviderWebsite.value)"
        >
          <img src="assets/img/sign-in-external.svg" />
          {{ mainProviderWebsite.text }} {{ 'label.SignIn' | translate }}
      </div>
      </div>
      <p-table
        [value]="jobseekerList"
        #dt
        [rowHover]="true"
        [lazy]="true"
        [paginator]="true"
        [rows]="pageSize"
        showGridlines
        (onLazyLoad)="onLoad($event)"
        [totalRecords]="totalRecords"
        (onRowExpand)="onExpandClick($event)"
        expandableRows="true"
        dataKey="jobseekerId"
        [expandedRowKeys]="jobseekerExpandedRows"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [pSortableColumn]="'fullName'">
              {{ 'label.Name' | translate }}, {{ 'label.Surname' | translate }}
              <p-sortIcon
                [field]="'fullName'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th [pSortableColumn]="'registrationDate'">
              {{ 'label.RegistrationDate' | translate }}
              <p-sortIcon
                [field]="'registrationDate'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th [pSortableColumn]="'lastVisitDate'">
              {{ 'label.LastVisit' | translate }}
              <p-sortIcon
                class="sortableIcon"
                [field]="'lastVisitDate'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th [pSortableColumn]="'profileState'">
              {{ 'label.ProfileStatus' | translate }}
              <p-sortIcon
                [field]="'profileState'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th [pSortableColumn]="'status'">
              {{ 'label.JobseekerStatus' | translate }}
              <p-sortIcon
                [field]="'status'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th [pSortableColumn]="'providerWebsiteName'">
              {{ 'label.Website' | translate }}
              <p-sortIcon
                [field]="'providerWebsiteName'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th>&nbsp;</th>
          </tr>
        </ng-template>
        <ng-template
          #body
          let-jobseeker
          let-columns="columns"
          let-expanded="expanded"
        >
          <tr>
            <td>
              <img
                [src]="
                  jobseeker.photoFilename !== null
                    ? jobseeker.photoFilename
                    : 'assets/img/jobseeker_no_photo_list.jpg'
                "
                width="58"
                height="70"
                alt=""
              />
              <a href="#" [pRowToggler]="jobseeker" class="arrow-icon">
                <ng-container
                  *ngIf="!expanded; else arrowUp"
                  class="arrow-down"
                >
                  <svg-icon src="assets/img/arrow_down.svg"></svg-icon>
                </ng-container>
                <ng-template #arrowUp>
                  <svg-icon src="assets/img/arrow_up.svg"></svg-icon>
                </ng-template>
              </a>
              <span class="jobseeker-edit-link">{{ jobseeker.fullName }}</span>
            </td>
            <td>
              <span>{{ jobseeker.registrationDate | date : dateFormat }}</span>
            </td>
            <td>
              <span
                [ngStyle]="{
                  color: switchLastVisitDateColor(jobseeker.lastVisitDate)
                }"
                >{{ jobseeker.lastVisitDate | date : dateFormat }}</span
              >
            </td>
            <td>
              <span
                [ngStyle]="{
                  color: switchProfileStateColor(jobseeker.profileStateId)
                }"
                >{{ jobseeker.profileState }}</span
              >
            </td>
            <td>
              <span
                [ngStyle]="{
                  color: switchJobseekerStatusColor(jobseeker.statusId)
                }"
                >{{ jobseeker.status }}</span
              >
            </td>
            <td>
              <span>{{ jobseeker.providerWebsiteName }}</span>
            </td>
            <td>
              <a
                *ngIf="jobseeker.statusId !== jobseekerStatusEnum.Rejected"
                [href]="
                  'https://' +
                  mainProviderWebsite.text +
                  '/admin/jobseeker-edit/' +
                  jobseeker.jobseekerId
                "
                class="sign-in-edit-button"
                target="_blank"
              >
                <img src="assets/img/sign_edit.svg" />
                {{ 'label.SignInOrEdit' | translate }}
              </a>
              <a
                *ngIf="jobseeker.hasPendingChanges"
                class="moderation-button"
                [routerLink]="[
                  '/jobseekers/moderation/',
                  jobseeker.jobseekerId
                ]"
                target="_blank"
              >
                {{ 'label.Moderate' | translate }}
              </a>
            </td>
          </tr>
        </ng-template>
        <!-- <p-column field="fullName" [sortable]="true" header="{{'label.Name' | translate}}, {{'label.Surname' | translate}}">
                    <ng-template let-col let-jobseeker="rowData" pTemplate="body">
                        <span class="jobseeker-edit-link"><a [routerLink]="['/jobseekers/edit', jobseeker.jobseekerId]">{{jobseeker[col.field]}}</a></span>
                    </ng-template>
                </p-column>
                <p-column field="registrationDate" [sortable]="true" header="{{'label.RegistrationDate' | translate}}">
                    <ng-template let-col let-jobseeker="rowData" pTemplate="body">
                        <span>{{jobseeker[col.field] | date:dateFormat}}</span>
                    </ng-template>
                </p-column>
                <p-column field="lastVisitDate" [sortable]="true" header="{{'label.LastVisit' | translate}}">
                    <ng-template let-col let-jobseeker="rowData" pTemplate="body">
                        <span>{{jobseeker[col.field] | date:dateFormat}}</span>
                    </ng-template>
                </p-column>
                <p-column field="profileState" [sortable]="true" header="{{'label.Profile' | translate}}"></p-column>
                <p-column field="status" [sortable]="true" header="{{'label.Status' | translate}}"></p-column>
                <p-column field="providerWebsiteName" [sortable]="true" header="{{'label.Website' | translate}}"></p-column>
                <p-column [style]="{'width':'35px'}">
                    <ng-template let-col let-jobseeker="rowData" pTemplate="body">
                        <p-button type="button" (click)="onJobseekerDelete(jobseeker)" icon="fa fa-times-circle"></p-button>
                    </ng-template>
                </p-column> -->
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="7">
              {{ 'message.NoRecordsFound' | translate }}
            </td>
          </tr>
        </ng-template>
        <ng-template #expandedrow let-jobseeker>
          <tr>
            <td colspan="9">
              <div
                class="ui-grid ui-grid-responsive ui-fluid"
                style="padding: 20px"
              >
                <app-jobseeker-list-details
                  [jobseekerProfile]="
                    providerWebsiteMap[jobseeker.providerWebsiteId] +
                    'admin/jobseeker-edit/' +
                    jobseeker.jobseekerId
                  "
                  [jobseekerDetails]="jobseeker?.jobseekerDetails"
                  (refreshPageEvent)="refresh()"
                ></app-jobseeker-list-details>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="9">
              {{ 'message.NoRecordsFound' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
